<div class="tp-email-verification">
  @switch (state.status) {
    @case ("pending") {
      <tp-spinner/>
    }
    @case ("emailSent") {
      <img class="tp-logo" src="https://typedb.com/assets/logo/typedb.svg" alt="TypeDB"/>

      <h1>Please verify your email</h1>

      <div class="tp-big-envelope"><i class="fa-thin fa-envelope"></i></div>

      <p style="margin-top: 40px">A link to verify your email has been sent to <strong>{{ state.email }}</strong></p>

      <hr/>

      <aside class="text-muted">
        Didn't receive it?
        <button class="button-secondary td-button-size-s" (click)="resendVerificationEmail()">Resend email</button>
      </aside>
      <aside class="text-muted">
        Not your account?
        <button class="button-secondary td-button-size-s" (click)="signOut()">Change email address</button>
      </aside>
    }
  }
</div>
